<template>
    <div class="main-container margin-b">
      <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
        You have only view permission.
      </div>
      <div>
          <run-payroll/>
          <!-- <quick-links class="quick-links"/> -->
      </div>
      <div  class="grid-container">
        <monthly-head-count class="head-count" />
         <quick-links class="quick-links"/>
          <!-- <employee-payroll class="employees" /> -->
          <!-- <holidays class="holidays" />
          <income-tax-declaration class="income" /> -->
      </div>
    </div>
</template>

<script>
import RunPayroll from './runpayroll.vue';
import Fbp from './fbp.vue';
import Holidays from './holidays.vue';
import IncomeTaxDeclaration from './incomeTaxDeclaration.vue';
import EmployeePayroll from './employeePayroll.vue';
import MonthlyHeadCount from './MonthlyHeadCount.vue';
import QuickLinks from './QuickLinks.vue';
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components:{
    RunPayroll,
    Fbp,
    Holidays,
    IncomeTaxDeclaration,
    EmployeePayroll,
    MonthlyHeadCount,
    QuickLinks
  },
  data() {
    return {
      payrollDashboardsValue: false,
      role: ""
    };
  },
  computed: {
    ...mapState({}),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if(this.payrollDashboardsValue) {
        return true;
        } else {
          return false;
        }
      }
      // else {
      //  return true
      // }
    },
  },
  activated() {
    this.getLockedPayrollMonth();
  },
  mounted() {
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),
    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.payrollDashboardsValue = data.data.user.permissions.payroll_dashboards ? true : false;
      //console.log("PL-3406",data);
    }
  }
}
</script>

<style lang="scss" scoped>
/* // eef2f6 */
.grid-container{
  display: flex;
  position: relative;
  // z-index: 3;
  flex-wrap: wrap;
  margin-bottom: 32px;
  background: #ffffff;
  >:nth-child(n) {
    margin-right: 32px;
  }
  >:last-child {
    margin-right: 0px;
  }
}
.payroll{
    background: white;
    width: 5%;
    flex: 3;
    height: auto;
    flex-grow: 3;
    border: 2px solid #eeeeee;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
}
.quick-links{
    background: white;
    flex-grow: 1;
    flex: 1;
    width: 30%;
    // width: auto;
    height: auto;
    border: 2px solid #eeeeee;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
}

.head-count{
    flex-grow: 5;
    flex: 3;
    background: white;
    width: 70%;
    // width: auto;
    height: auto;
    min-height: 500px;
    border: 2px solid #eeeeee;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
}


.employees{
    flex-grow: 5;
    flex: 5;
    background: white;
    width: 62.5%;
    // width: auto;
    height: auto;
    border: 2px solid #eeeeee;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
}
.holidays{
    flex: 1;
    flex-grow: 1;
    background: white;
    width: 12.5%;
    min-width: 200px;
    // width: auto;
    height: auto;
    border: 2px solid #eeeeee;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
    // margin-top: -54px;
}
.income{
    flex: 2;
    flex-grow: 2;
    background: white;
    width: 25%;
    // width: auto;
    height: auto;
    border: 2px solid #eeeeee;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
}
.margin-b {
  margin-bottom: 0;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
